
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartSeabedProposal as ObiChartSeabedProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-seabed-proposal.js';
 
 
 

 
 export const ObiChartSeabedProposal = createComponent({
   react: React,
   tagName: 'obi-chart-seabed-proposal',
   elementClass: ObiChartSeabedProposalElement,
   events: {
     
   }
  });
 
 